import type { IdsMessageSettings } from './ids-message';
import IdsMessage from './ids-message';

/**
 * IDS Notification Service
 */
export default class IdsMessageService {
  /* Show a notification Banner */
  static show(settings: IdsMessageSettings) {
    const message = document.createElement('ids-message') as IdsMessage;
    document.body.appendChild(message);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    message.show(settings);
  }

  /* Close All notification Banner */
  static hide(id: string) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (document.querySelector(`#${id}`) as IdsMessage)?.hide();
  }
}
